/**
 * Hotfix for production web blank-page crash:
 *   "Cannot read properties of undefined (reading 'EventEmitter')"
 *
 * Why this file exists:
 *   `expo-modules-core` ships a side-effect-only module
 *   (`src/polyfill/index.web.ts`) that installs `globalThis.expo` (EventEmitter,
 *   NativeModule, SharedObject, SharedRef, ...). The Metro production tree-shaker
 *   shipped with Expo SDK 54.0.34 drops that side-effect import even though
 *   `expo-modules-core/package.json` lists `./src/polyfill/*.ts` in `sideEffects`.
 *   That left `globalThis.expo` undefined in the prod web bundle and crashed the
 *   first read of `globalThis.expo.EventEmitter` (e.g. inside `expo-linking`).
 *   It works in `expo start --web` because dev mode does not tree-shake.
 *
 * Why the call is here (not in `_layout.tsx` or via a bare `import`):
 *   The expo-modules-core public subpath export `./src/polyfill/dangerous-internal`
 *   exposes the installer. By calling it here, Metro can never tree-shake the
 *   reference — and because this file is the very first import of `index.js`,
 *   ES module evaluation order guarantees `globalThis.expo` is set before
 *   `expo-router` / `expo-linking` / `expo-modules-core` initialize.
 *
 * Native is unaffected: `globalThis.expo` is installed by JSI before JS runs,
 * so `installExpoGlobalPolyfill()` returns early on iOS/Android.
 */
import { installExpoGlobalPolyfill } from 'expo-modules-core/src/polyfill/dangerous-internal';

installExpoGlobalPolyfill();

// Polyfill window.location for React Native — @supabase/auth-js reads
// window.location.hostname at module level with no null guard. This must live
// here (not in index.js inline code) because ES module `import` declarations
// are hoisted and run before any inline code in index.js executes.
if (typeof window !== 'undefined' && window.location == null) {
  Object.defineProperty(window, 'location', {
    value: { hostname: '', href: '', origin: '', pathname: '/', search: '', hash: '', port: '', protocol: 'https:', host: '' },
    writable: true,
    configurable: true,
  });
}
